import React from 'react'
import { Image, Link, StartTrialButtonWithModal, CtaArrow } from 'newComponents'
import './styles.scss'
import classNames from 'classnames'
import checkmark from '../../images/_icons/checkmark-green.svg'

const PricingFeatureTable = (data) => {
  const { heading, body } = data
  const {
    primary: { table_heading: tableHeading },
    items: tableHeads
  } = heading[0]

  const renderCheckmark = (text) => {
    if (text === 'y') {
      return <Image image={checkmark} />
    }
    return text
  }

  const HeaderButtons = (headerButtons) => {
    const {
      data: { column_cta_text: ctaText, column_cta_url: ctaUrl }
    } = headerButtons

    if (ctaUrl.url.length <= 0) {
      return (
        <StartTrialButtonWithModal
          cta={ctaText.text}
          classes="button is-primary modal-trigger"
          trackEvent="Start 14-Day Free Trial Button Clicked"
          addArrow
        />
      )
    }
    return (
      <Link className="button is-primary button-link" to={ctaUrl.url}>
        {ctaText.text} <CtaArrow />
      </Link>
    )
  }

  const toggleTooltip = (e) => {
    const el = e.currentTarget
    const parent = el.parentElement
    const tip = parent.lastElementChild

    if (tip) {
      if (parent.className.indexOf('tip-open') < 0) {
        parent.className += ' tip-open'
      } else {
        parent.className = parent.className.replace(' tip-open', '')
      }
    }
  }

  return (
    <div className="pricing-feature-table">
      <div className="container">
        <h2 className="pricing-feature-table-heading">{tableHeading.text}</h2>
        <div className="pricing-feature-table-table-head-bar lg-screen">
          <div className="pricing-feature-table-table-head">
            <div className="pricing-feature-table-table-head-col empty-col" />
            {tableHeads.map((tableHead) => {
              return (
                <div key={tableHead.column_heading.text} className="pricing-feature-table-table-head-col">
                  <h6 className="pricing-feature-table-table-header">{tableHead.column_heading.text}</h6>
                  <HeaderButtons data={tableHead} />
                </div>
              )
            })}
          </div>
        </div>
        <div className="pricing-feature-table-table">
          <div className="pricing-feature-table-table-inner">
            <div className="mobile-header sm-screen">
              {body.map((featureGroup) => {
                const {
                  primary: { table_section_icon: sectionIcon, table_section_name: sectionName },
                  items
                } = featureGroup
                return (
                  <div key={sectionName.text} className="pricing-feature-table-table-body-feature-group">
                    <div className="pricing-feature-table-table-body-feature-title">
                      <Image className="pricing-feature-table-table-body-feature-title-icon" image={sectionIcon} />
                      <h4>{sectionName.text}</h4>
                    </div>
                    {items.map((row) => {
                      const {
                        table_row_title: { text: rowTitle },
                        table_row_tooltip: { text: tooltip }
                      } = row
                      return (
                        <div key={`${rowTitle}-b`} className="pricing-feature-table-table-body-feature-row">
                          <div
                            className={classNames('pricing-feature-table-table-body-feature-col title-col', {
                              'with-tooltip': tooltip
                            })}
                          >
                            <span
                              className="pricing-feature-table-table-body-feature-col-row-title border-wrap"
                              onMouseEnter={toggleTooltip}
                              onMouseLeave={toggleTooltip}
                            >
                              {rowTitle}
                            </span>
                            {tooltip && (
                              <div className="pricing-feature-table-tooltip">
                                <div className="triangle-with-shadow" />
                                <div className="pricing-feature-table-tooltip-inner">{tooltip}</div>
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )
              })}
            </div>
            <div className="pricing-feature-table-table-body">
              <div className='main-container'>
                <div className="pricing-feature-table-table-head-bar sm-screen">
                  <div className="pricing-feature-table-table-head">
                    <div className="pricing-feature-table-table-head-col empty-col" />
                    {tableHeads.map((tableHead) => {
                      return (
                        <div key={tableHead.column_heading.text} className="pricing-feature-table-table-head-col">
                          <h6 className="pricing-feature-table-table-header">{tableHead.column_heading.text}</h6>
                          <HeaderButtons data={tableHead} />
                        </div>
                      )
                    })}
                  </div>
                </div>
                {body.map((featureGroup) => {
                  const {
                    primary: { table_section_icon: sectionIcon, table_section_name: sectionName },
                    items
                  } = featureGroup

                  return (
                    <div key={sectionName.text} className="pricing-feature-table-table-body-feature-group">
                      <div className="pricing-feature-table-table-body-feature-title">
                        <Image className="pricing-feature-table-table-body-feature-title-icon" image={sectionIcon} />
                        <h4>{sectionName.text}</h4>
                      </div>
                      {items.map((row) => {
                        const {
                          table_row_title: { text: rowTitle },
                          table_row_tooltip: { text: tooltip },
                          first_column_text: { text: firstCol },
                          second_column_text: { text: secondCol },
                          third_column_text: { text: thirdCol }
                        } = row
                        return (
                          <div key={rowTitle} className="pricing-feature-table-table-body-feature-row">
                            <div
                              className={classNames('pricing-feature-table-table-body-feature-col title-col', {
                                'with-tooltip': tooltip
                              })}
                            >
                              <span onMouseEnter={toggleTooltip} onMouseLeave={toggleTooltip} className="border-wrap">
                                {rowTitle}
                              </span>
                              {tooltip && (
                                <div className="pricing-feature-table-tooltip">
                                  <div className="triangle-with-shadow" />
                                  <div className="pricing-feature-table-tooltip-inner">{tooltip}</div>
                                </div>
                              )}
                            </div>
                            <div className="pricing-feature-table-table-body-feature-col first-col">
                              {renderCheckmark(firstCol)}
                            </div>
                            <div className="pricing-feature-table-table-body-feature-col second-col">
                              {renderCheckmark(secondCol)}
                            </div>
                            <div className="pricing-feature-table-table-body-feature-col third-col">
                              {renderCheckmark(thirdCol)}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PricingFeatureTable
